import CompanyInfoTabContent from "../companyInfo/CompanyInfoTabContent";
import ContractsTabContent from "../contract/ContractsTabContent";
import CustomerCostCenters from "../customerCostCenters/CustomerCostCenters";
import OrderTemplateList from "../orderTemplate/OrderTemplateList";
import { PoolsTab } from "../pools/PoolsTab";
import { TabValue } from "../types/types";
import UsersTable from "../users/UsersTable";
import WorkLocations from "../workLocations/WorkLocations";
import { TabPanelContainer } from "./styles";

type Props = {
  tabValue: TabValue;
};

const TabPanelComponent = ({ tabValue }: Props) => {
  const tabPanelComponents = {
    basicInfo: <CompanyInfoTabContent />,
    workLocations: <WorkLocations />,
    orderTemplates: <OrderTemplateList />,
    customerCostCenters: <CustomerCostCenters />,
    contracts: <ContractsTabContent />,
    users: <UsersTable />,
    pools: <PoolsTab />,
  };

  return <TabPanelContainer>{tabPanelComponents[tabValue]}</TabPanelContainer>;
};

export default TabPanelComponent;
